import { format, parseISO, isValid } from "date-fns";

/**
 * Standard date format for Koredor: "Monday, March 27, 2026"
 */
export function formatStandardDate(dateStr: string | Date | undefined | null): string {
  if (!dateStr) return "—";
  try {
    const date = typeof dateStr === "string" ? parseISO(dateStr) : dateStr;
    if (!isValid(date)) return String(dateStr);
    return format(date, "EEEE, MMMM d, yyyy");
  } catch {
    return String(dateStr);
  }
}

/** Short format: "Mar 27, 2026" */
export function formatShortDate(dateStr: string | Date | undefined | null): string {
  if (!dateStr) return "—";
  try {
    const date = typeof dateStr === "string" ? parseISO(dateStr) : dateStr;
    if (!isValid(date)) return String(dateStr);
    return format(date, "MMM d, yyyy");
  } catch {
    return String(dateStr);
  }
}

/** Timestamp format: "Monday, March 27, 2026 at 2:30 PM" */
export function formatStandardTimestamp(dateStr: string | Date | undefined | null): string {
  if (!dateStr) return "—";
  try {
    const date = typeof dateStr === "string" ? new Date(dateStr) : dateStr;
    if (!isValid(date)) return String(dateStr);
    return format(date, "EEEE, MMMM d, yyyy 'at' h:mm a");
  } catch {
    return String(dateStr);
  }
}
